import { motion } from 'framer-motion';

export const Hero = () => {
  return (
    <section className="min-h-[100svh] w-full relative flex items-end overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1643009008520-72805ad2a1c0?q=85&w=1920"
          alt="Luxury Highrise"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/30 md:from-black/70 md:via-black/20 md:to-transparent"></div>
      </div>

      {/* Logo on hero */}
      <div className="absolute top-5 left-5 md:top-8 md:left-auto md:right-12 z-20">
        <img src="/logo.png" alt="The NRI Realtor" className="h-9 md:h-14" data-testid="hero-logo" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-12 pb-12 md:pb-24 pt-28 md:pt-0">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-[10px] md:text-sm uppercase tracking-widest text-brand-gold-light mb-3 md:mb-4"
          data-testid="hero-subtitle"
        >
          Integrity That Truly Matters
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="text-[2.4rem] sm:text-5xl md:text-6xl lg:text-8xl font-heading font-light text-white mb-3 md:mb-4 tracking-tight leading-[1.05]"
          data-testid="hero-title"
        >
          Find Your<br />Dream Estate
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-sm md:text-xl text-white/70 font-light mb-6 md:mb-8 max-w-xl"
          data-testid="hero-description"
        >
          Luxury Homes in Bangalore for the Global Indian
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          className="inline-flex flex-wrap items-center gap-2 md:gap-5 px-4 md:px-6 py-2 md:py-3 rounded-full border border-white/20 backdrop-blur-md bg-white/10"
          data-testid="hero-builders-strip"
        >
          <span className="text-[9px] md:text-xs uppercase tracking-widest text-brand-gold-light whitespace-nowrap">Trusted by</span>
          <div className="hidden md:block w-px h-4 bg-white/20"></div>
          {['Brigade', 'Shobha', 'Concorde', 'Royal Indraprastha', 'Sattva'].map((builder, index) => (
            <span key={builder} className="flex items-center gap-2 md:gap-5">
              <a href="#builders" className="text-[10px] md:text-sm font-body text-white/70 hover:text-white transition-colors whitespace-nowrap" data-testid={`hero-builder-${index}`}>{builder}</a>
              {index < 4 && <span className="text-white/20 hidden md:inline">|</span>}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
